import React from 'react';

const HSNCodeTable = (props) => {
    return (
        <div className="itemList-table w-full">
            <div className="table-container max-h-[378px] min-h-[298px] h-full overflow-y-scroll">
                <table className="itemList">
                    <thead>
                        <tr>
                            <td className='w-[4%]'>Sr.</td>
                            <td className='w-[19%]'>HSN Code</td>
                            <td className='w-[17%]'>Amount</td>
                            <td className='w-[8%]'>SGST Rate</td>
                            <td className='w-[12%]'>SGST Amount</td>
                            <td className='w-[8%]'>CGST Rate</td>
                            <td className='w-[12%]'>CGST Amount</td>
                            <td className='w-[8%]'>IGST Rate</td>
                            <td className='w-[12%]'>IGST Amount</td>


                        </tr>
                    </thead>
                    <tbody>
                        {props.hsnCodeListForTable && props.hsnCodeListForTable.length > 0
                            ? props.hsnCodeListForTable.map((item, key) => (

                                <tr key={key}>
                                    <td>{key + 1}</td>
                                    <td>{item.label}</td>
                                    <td>{item.taxableAmount}</td>
                                    <td>{item.sgstRate}%</td>
                                    <td>{item.sgstAmount}</td>
                                    <td>{item.cgstRate}%</td>
                                    <td>{item.cgstAmount}</td>
                                    <td>{item.igstRate}%</td>
                                    <td>{item.igstAmount}</td>
                                    {/* <td>{item.utgstRate}%</td>
                                    <td>{item.utgstAmount}</td> */}
                                </tr>
                            ))
                            : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default HSNCodeTable;